export default {
    default: {
        '--C_129': '#eaf2ff',
        '--C_171': '#95B8E7',
        '--C_174': '#E0ECFF',
        '--C_175': '#EFF5FF 0, #E0ECFF 100%',
        '--C_176': '#EFF5FF 0, #E0ECFF 100%',
        '--C_177': '#EFF5FF 0, #E0ECFF 100%',
        '--C_178': '#EFF5FF 0, #E0ECFF 100%',
        '--C_180': 'startColorstr=#EFF5FF, endColorstr=#EFF5FF, GradientType=0',
        '--C_181': '#0E2D5F',
        '--C_184': '#ffffff',
        '--C_185': '#000000',
        '--C_191': '#0E2D5F',
        '--C_196': '#95B8E7',
        '--C_198': '#F4F4F4',
        '--C_199': '#000000',
        '--C_357': '#ffffff',
        '--C_358': '#95B8E7',
        '--C_361': '#E0ECFF',
        '--C_365': '#ffe48d',
        '--C_368': '#000000',
        '--C_371': '#E0ECFF',
        '--C_374': '#ffffff',
        '--C_378': '#95B8E7',
        '--C_390': '#E0ECFF',
        '--C_393': '#ffffff',
        '--C_397': '#95B8E7',
        '--C_409': '#E0ECFF',
        '--C_412': '#ffffff',
        '--C_416': '#95B8E7',
        '--C_481': '#ccc',
        '--C_482': '#cccccc',
        '--C_483': '#cccccc',
        '--C_484': '#cccccc',
        '--C_489': '#95B8E7',
        '--C_492': '#E0ECFF',
        '--C_493': '#EFF5FF 0, #E0ECFF 20%',
        '--C_494': '#EFF5FF 0, #E0ECFF 20%',
        '--C_495': '#EFF5FF 0, #E0ECFF 20%',
        '--C_496': '#EFF5FF 0, #E0ECFF 20%',
        '--C_498': 'startColorstr=#EFF5FF, endColorstr=#E0ECFF, GradientType=0',
        '--C_501': '#95B8E7',
        '--C_505': '#ccc',
        '--C_508': '#95B8E7',
        '--C_616': '#ccc',
        '--C_617': '#fff',
        '--C_631': '#F4F4F4',
        '--C_636': '#95B8E7 #95B8E7 #dddddd #95B8E7',
        '--C_639': '#dddddd #95B8E7 #95B8E7 #95B8E7',
        '--C_644': '#F4F4F4',
        '--C_654': '#ccc',
        '--C_802': '#444',
        '--C_803': '#fafafa',
        '--C_805': '#bbb',
        '--C_806': '#ffffff 0, #eeeeee 100%',
        '--C_807': '#ffffff 0, #eeeeee 100%',
        '--C_808': '#ffffff 0, #eeeeee 100%',
        '--C_809': '#ffffff 0, #eeeeee 100%',
        '--C_811': 'startColorstr=#ffffff, endColorstr=#eeeeee, GradientType=0',
        '--C_817': '#eaf2ff',
        '--C_818': '#000000',
        '--C_819': '#b7d2ff',
        '--C_829': '#b7d2ff',
        '--C_833': '#eaf2ff',
        '--C_834': '#000000',
        '--C_835': '#b7d2ff',
        '--C_844': '#fafafa',
        '--C_845': '#444',
        '--C_846': '#ffffff 0, #eeeeee 100%',
        '--C_847': '#ffffff 0, #eeeeee 100%',
        '--C_848': '#ffffff 0, #eeeeee 100%',
        '--C_849': '#ffffff 0, #eeeeee 100%',
        '--C_851': 'startColorstr=#ffffff, endColorstr=#eeeeee, GradientType=0',
        '--C_864': '#ddd',
        '--C_869': '#ddd',
        '--C_873': '#95B8E7',
        '--C_1014': '#6b9cde',
        '--C_1015': '#95B8E7',
        '--C_1016': '#95B8E7',
        '--C_1017': '#95B8E7',
        '--C_1091': '#ffffff',
        '--C_1094': '#E0ECFF',
        '--C_1097': '#eaf2ff',
        '--C_1100': '#eaf2ff',
        '--C_1131': '#eaf2ff',
        '--C_1132': '#000000',
        '--C_1135': '#ffe48d',
        '--C_1136': '#000000',
        '--C_1162': '#eaf2ff',
        '--C_1163': '#000000',
        '--C_1319': '#aac5e7',
        '--C_1322': '#E6EEF8',
        '--C_1325': '#E6EEF8',
        '--C_1328': '#E6EEF8',
        '--C_1331': '#E6EEF8',
        '--C_1334': '#E0ECFF',
        '--C_1337': '#E0ECFF',
        '--C_1654': '#E0ECFF',
        '--C_1657': '#E0ECFF',
        '--C_1663': '#eaf2ff',
        '--C_1664': '#000000',
        '--C_1668': '#ffffff',
        '--C_1669': '#0E2D5F',
        '--C_1670': '#EFF5FF 0, #ffffff 100%',
        '--C_1671': '#EFF5FF 0, #ffffff 100%',
        '--C_1672': '#EFF5FF 0, #ffffff 100%',
        '--C_1673': '#EFF5FF 0, #ffffff 100%',
        '--C_1675': 'startColorstr=#EFF5FF, endColorstr=#ffffff, GradientType=0',
        '--C_1678': '#ffffff 0, #EFF5FF 100%',
        '--C_1679': '#ffffff 0, #EFF5FF 100%',
        '--C_1680': '#ffffff 0, #EFF5FF 100%',
        '--C_1681': '#ffffff 0, #EFF5FF 100%',
        '--C_1683': 'startColorstr=#ffffff, endColorstr=#EFF5FF, GradientType=0',
        '--C_1686': '#EFF5FF 0, #ffffff 100%',
        '--C_1687': '#EFF5FF 0, #ffffff 100%',
        '--C_1688': '#EFF5FF 0, #ffffff 100%',
        '--C_1689': '#EFF5FF 0, #ffffff 100%',
        '--C_1691': 'startColorstr=#EFF5FF, endColorstr=#ffffff, GradientType=1',
        '--C_1694': '#ffffff 0, #EFF5FF 100%',
        '--C_1695': '#ffffff 0, #EFF5FF 100%',
        '--C_1696': '#ffffff 0, #EFF5FF 100%',
        '--C_1697': '#ffffff 0, #EFF5FF 100%',
        '--C_1699': 'startColorstr=#ffffff, endColorstr=#EFF5FF, GradientType=1',
        '--C_1702': '#0E2D5F',
        '--C_1703': '#E0ECFF',
        '--C_1704': '#EFF5FF 0, #E0ECFF 100%',
        '--C_1705': '#EFF5FF 0, #E0ECFF 100%',
        '--C_1706': '#EFF5FF 0, #E0ECFF 100%',
        '--C_1707': '#EFF5FF 0, #E0ECFF 100%',
        '--C_1709': 'startColorstr=#EFF5FF, endColorstr=#E0ECFF, GradientType=0',
        '--C_1713': '#E0ECFF',
        '--C_1729': '#95B8E7',
        '--C_1734': '#eaf2ff',
        '--C_1737': '#ffffff',
        '--C_1740': '#ffffff',
        '--C_1743': '#ffffff',
        '--C_1746': '#ffffff',
        '--C_1749': '#ffe48d',
        '--C_1750': '#000000',
        '--C_1752': '#95B8E7',
        '--C_1817': '#ccc',
        '--C_1818': '#fff',
        '--C_1946': '#95B8E7',
        '--C_1978': '#ffffff',
        '--C_1982': '#efefef',
        '--C_1983': '#F9F9F9 0, #efefef 100%',
        '--C_1984': '#F9F9F9 0, #efefef 100%',
        '--C_1985': '#F9F9F9 0, #efefef 100%',
        '--C_1986': '#F9F9F9 0, #efefef 100%',
        '--C_1988': 'startColorstr=#F9F9F9, endColorstr=#efefef, GradientType=0',
        '--C_1991': '#000000',
        '--C_1994': '#aac5e7',
        '--C_1997': '#ccc',
        '--C_2000': '#95B8E7',
        '--C_2004': '#F4F4F4',
        '--C_2010': '#dddddd',
        '--C_2015': '#ccc',
        '--C_2020': '#000000',
        '--C_2024': '#fafafa',
        '--C_2028': '#eaf2ff',
        '--C_2029': '#000000',
        '--C_2033': '#ffe48d',
        '--C_2034': '#000000',
        '--C_2051': '#ffab3f',
        '--C_2054': '#ffab3f',
        '--C_2072': '#dddddd',
        '--C_2075': '#E0ECFF',
        '--C_2078': '#dddddd',
        '--C_2084': '#E0ECFF',
        '--C_2095': '#efefef',
        '--C_2098': '#ccc',
        '--C_2135': '#000000',
        '--C_2172': '#ccc',
        '--C_2175': '#eaf2ff',
        '--C_2176': '#000000',
        '--C_2195': '#ccc',
        '--C_2196': '#fff',
        '--C_2256': '#95B8E7',
        '--C_2415': '#4d4d4d',
        '--C_2418': '#000000',
        '--C_2430': '#95B8E7',
        '--C_2433': '#95B8E7',
        '--C_2436': '#E0ECFF',
        '--C_2440': '#ffffff',
        '--C_2443': '#F4F4F4',
        '--C_2449': '#eaf2ff',
        '--C_2450': '#000000',
        '--C_2453': '#b7d2ff',
        '--C_2457': '#ffe48d',
        '--C_2458': '#000000',
        '--C_2459': '#ffab3f',
        '--C_2463': '#E0ECFF',
        '--C_2502': '#F4F4F4',
        '--C_2505': '#444',
        '--C_2521': '#E0ECFF',
        '--C_2533': '#444',
        '--C_2535': '#E0ECFF',
        '--C_2578': '#eaf2ff',
        '--C_2590': '#eaf2ff',
        '--C_2600': '#E0ECFF',
        '--C_2609': '#E0ECFF',
        '--C_2613': '#E0ECFF',
        '--C_2643': '#95B8E7',
        '--C_2646': '#000000',
        '--C_2651': '#ffe48d',
        '--C_2652': '#000000',
        '--C_2708': '#E0ECFF',
        '--C_2807': '#95B8E7',
        '--C_2808': '#E0ECFF',
        '--C_2811': '#95B8E7',
        '--C_2814': '#000000',
        '--C_2896': '#ccc',
        '--C_2897': '#cccccc',
        '--C_2898': '#cccccc',
        '--C_2899': '#cccccc',
        '--C_2906': '#ccc',
        '--C_2907': '#fff',
        '--C_2910': '#ccc',
        '--C_2911': '#fff',
        '--C_2914': '#fafafa',
        '--C_2915': '#ddd',
        '--C_2916': '#444',
        '--C_2919': '#ffffff',
        '--C_2923': '#fafafa',
        '--C_2926': '#b7d2ff',
        '--C_2927': '#000000',
        '--C_2928': '#eaf2ff',
        '--C_2933': '#444',
        '--C_2948': '#eaf2ff',
        '--C_2949': '#000000',
        '--C_2950': '#b7d2ff',
        '--C_3002': '#aac5e7',
        '--C_3025': '#b7d2ff',
        '--C_3026': '#eaf2ff',
        '--C_3027': '#000000',
        '--C_3038': '#aac5e7',
        '--C_3080': '#95B8E7',
        '--C_3086': '#ccc',
        '--C_3251': '#95B8E7',
        '--C_3264': '#ffffff',
        '--C_3265': '#000000',
        '--C_3266': '#95B8E7',
        '--C_3269': '#eaf2ff',
        '--C_3270': '#000000',
        '--C_3273': '#ffe48d',
        '--C_3274': '#000000',
        '--C_3369': '#ffffff',
        '--C_3370': '#95B8E7',
        '--C_3371': '#000000',
        '--C_3374': '#95B8E7',
        '--C_3377': '#ffffff',
        '--C_3380': '#95B8E7',
        '--C_3383': '#ffffff',
        '--C_3386': '#95B8E7',
        '--C_3389': '#ffffff',
        '--C_3392': '#95B8E7',
        '--C_3395': '#ffffff',
        '--C_3405': '#bbb',
        '--C_3406': '#bbb',
        '--C_3431': '#ffe48d',
        '--C_3432': '#000000',
        '--C_3435': '#ffffff',
        '--C_3436': '#000000',
        '--C_3454': '#ffffff',
        '--C_3455': '#000000',
        '--C_3456': '#bbb',
        '--C_3457': '#bbb',
        '--C_3458': '#bbb',
        '--C_3459': '#bbb',
        '--C_3475': '#bbb',
        '--C_3476': '#bbb',
        '--C_3477': '#bbb',
        '--C_3482': '#ffab3f',
        '--C_3491': '#ffab3f',
        '--C_3507': '#ffab3f',
        '--C_3514': '#ffab3f',
        '--C_3549': '#0E2D5F',
        '--C_3554': '#0E2D5F',
        '--C_3557': '#eaf2ff',
        '--C_3558': '#0E2D5F',
        '--C_3561': '#eaf2ff',
        '--C_3562': '#0E2D5F',
        '--C_3565': '#ffab3f',
        '--C_3566': '#000000',
        '--C_3567': '#ffe48d',
        '--C_3619': '#E0ECFF',
        '--C_3620': '#0E2D5F',
        '--C_3640': '#ffab3f',
        '--C_3641': '#000000',
        '--C_3654': '#ffab3f',
        '--C_3661': '#ffab3f',
        '--C_3665': '#000000',
        '--C_3675': '#ffab3f'
    }
}